import { render, staticRenderFns } from "./Huanbaoadmin.vue?vue&type=template&id=726c7b8e&scoped=true"
import script from "./Huanbaoadmin.vue?vue&type=script&lang=js"
export * from "./Huanbaoadmin.vue?vue&type=script&lang=js"
import style0 from "./Huanbaoadmin.vue?vue&type=style&index=0&id=726c7b8e&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726c7b8e",
  null
  
)

export default component.exports